import React from "react";

function Footer() {
  return (
    <>
      <footer>
        <div className="container text-center section-padding-y">
          <div className="row px-4">
            <div className="col-lg-7 mx-auto">
              <h2 className="text-uppercase mb-0">ADEBAYO ABIODUN </h2>
              <h6 className="text-primary text-uppercase mb-0 letter-spacing-3">
                FullStack Web Developer
              </h6>
              <p className="text-muted my-4">
                A seasoned Web Based Developer with over 3years of wealth of
                experiences in Inforamtion Technology. I’m hard working, super
                curious, passionate, committed, and also a fast learner!
              </p>
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a className="social-link" href="#">
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a className="social-link" href="#">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a className="social-link" href="#">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a className="social-link" href="#">
                    <i className="fab fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="copyrights px-4">
          <div className="container py-4 border-top text-center">
            <p className="mb-0 text-muted py-2">
              © All rights reserved. {}
              <a href="">Adebayo Portfilo</a>.{" "}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
